/* global Shopify */
(function () {
  'use strict';

  var root = document.documentElement;
  var activeDrawer = null;
  var restoreFocus = null;

  function focusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ));
  }

  function setDrawerState(details, open) {
    if (!details) return;
    if (open) {
      activeDrawer = details;
      restoreFocus = details.querySelector('summary');
      root.classList.add('is-drawer-open');
      var drawer = details.querySelector('.site-header__drawer');
      if (drawer) drawer.scrollTop = 0;
      var first = focusable(drawer)[0];
      if (first) window.requestAnimationFrame(function () { first.focus({ preventScroll: true }); });
    } else {
      root.classList.remove('is-drawer-open');
      if (activeDrawer === details) activeDrawer = null;
      if (restoreFocus && document.contains(restoreFocus)) restoreFocus.focus();
      restoreFocus = null;
    }
  }

  function closeDrawer() {
    if (!activeDrawer) return;
    activeDrawer.open = false;
    setDrawerState(activeDrawer, false);
  }

  function getShopifyFormsDialog(formId) {
    var embed = document.getElementById('app-embed-container-' + formId);
    if (!embed) return null;
    if (formId === '1116722') {
      embed.style.setProperty('--container-max-w', '600px');
      embed.style.setProperty('--forms-padding-top', '24px');
      embed.style.setProperty('--forms-padding-bottom', '24px');
      embed.style.setProperty('--forms-padding-left', '32px');
      embed.style.setProperty('--forms-padding-right', '32px');
      embed.style.setProperty('--form-field-padding', '12px');
      embed.style.setProperty('--button-padding', '12px');
    }
    if (!embed.shadowRoot) return null;
    return embed.shadowRoot.querySelector('[role="dialog"][aria-modal="true"]');
  }

  function focusShopifyFormsDialog(formId) {
    var dialog = getShopifyFormsDialog(formId);
    if (!dialog) return false;
    if (typeof dialog.focus === 'function') dialog.focus();
    return true;
  }

  function resetShopifyFormsPopupState(formId) {
    try {
      window.localStorage.removeItem(formId + '-dismissed-after-submit');
      window.localStorage.removeItem(formId + '-dismissed-in-session');
      window.localStorage.removeItem(formId + '-minimized-in-session');
    } catch (error) {
      // Shopify Forms can still open when browser storage is unavailable.
    }

    window.ShopifyForms = window.ShopifyForms || {};
    window.ShopifyForms.disableDismissTracker = true;
    window.ShopifyForms.triggerExitIntent = true;
  }

  function showShopifyFormsPopup(formId, trigger) {
    window.HavenForms = window.HavenForms || {};
    window.HavenForms.pendingPopupId = formId;
    if (trigger) window.HavenForms.restoreFocus = trigger;

    var embed = document.getElementById('app-embed-container-' + formId);
    if (!embed) return;

    embed.setAttribute('data-haven-popup-open', 'preparing');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (window.HavenForms.pendingPopupId === formId) {
          embed.setAttribute('data-haven-popup-open', 'true');
        }
      });
    });
  }

  function openShopifyFormsPopup(formId, trigger) {
    resetShopifyFormsPopupState(formId);
    showShopifyFormsPopup(formId, trigger);
    if (focusShopifyFormsDialog(formId)) return;

    var attempts = 0;
    var maxAttempts = 75;

    function tryOpenPopup() {
      if (focusShopifyFormsDialog(formId)) return;

      document.dispatchEvent(new Event('forms:exit-intent:' + formId));
      attempts += 1;

      if (attempts < maxAttempts) window.setTimeout(tryOpenPopup, 80);
    }

    tryOpenPopup();
  }

  function init(container) {
    var scope = container || document;
    var drawers = scope.querySelectorAll ? scope.querySelectorAll('[data-mobile-drawer]') : [];
    Array.prototype.forEach.call(drawers, function (details) {
      if (details.dataset.havenInitialized === 'true') return;
      details.dataset.havenInitialized = 'true';
      details.addEventListener('toggle', function () {
        setDrawerState(details, details.open);
      });
      var closeButton = details.querySelector('[data-drawer-close]');
      if (closeButton) closeButton.addEventListener('click', function () {
        details.open = false;
        setDrawerState(details, false);
      });
    });

    var disclosures = scope.querySelectorAll ? scope.querySelectorAll('[data-disclosure]') : [];
    Array.prototype.forEach.call(disclosures, function (disclosure) {
      if (disclosure.dataset.havenInitialized === 'true') return;
      disclosure.dataset.havenInitialized = 'true';
      disclosure.addEventListener('toggle', function () {
        if (!disclosure.open) return;
        Array.prototype.forEach.call(document.querySelectorAll('[data-disclosure][open]'), function (sibling) {
          if (sibling !== disclosure) sibling.open = false;
        });
      });
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (activeDrawer) {
        event.preventDefault();
        closeDrawer();
        return;
      }
      var openDisclosure = document.querySelector('[data-disclosure][open]');
      if (openDisclosure) {
        openDisclosure.open = false;
        var summary = openDisclosure.querySelector('summary');
        if (summary) summary.focus();
      }
    }

    if (event.key === 'Tab' && activeDrawer) {
      var drawer = activeDrawer.querySelector('.site-header__drawer');
      var items = focusable(drawer);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  document.addEventListener('click', function (event) {
    var popupTrigger = event.target.closest ? event.target.closest('[data-shopify-forms-popup-id]') : null;
    if (
      popupTrigger
      && !event.defaultPrevented
      && event.button === 0
      && !event.metaKey
      && !event.ctrlKey
      && !event.shiftKey
      && !event.altKey
    ) {
      var popupFormId = popupTrigger.getAttribute('data-shopify-forms-popup-id');
      if (/^\d+$/.test(popupFormId || '')) {
        event.preventDefault();
        if (activeDrawer && activeDrawer.contains(popupTrigger)) closeDrawer();
        openShopifyFormsPopup(popupFormId, popupTrigger);
        return;
      }
    }

    if (!activeDrawer) return;
    if (event.target.closest && event.target.closest('[data-drawer-navigation]')) {
      closeDrawer();
      return;
    }
    if (!activeDrawer.contains(event.target)) closeDrawer();
  });

  document.addEventListener('DOMContentLoaded', function () { init(document); });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var unloadedDrawer = event.target && event.target.querySelector ? event.target.querySelector('[data-mobile-drawer]') : null;
    if (unloadedDrawer && activeDrawer === unloadedDrawer) {
      activeDrawer = null;
      restoreFocus = null;
      root.classList.remove('is-drawer-open');
    }
  });

  window.HavenTheme = window.HavenTheme || {};
  window.HavenTheme.init = init;
}());
// Keep uploaded HTML videos silent, including dynamically inserted media.
(function () {
  'use strict';
  if (window.havenVideoMuteInitialized) return;
  window.havenVideoMuteInitialized = true;

  function mute(video) {
    if (!video || video.nodeName !== 'VIDEO') return;
    if (!video.defaultMuted) video.defaultMuted = true;
    if (!video.muted) video.muted = true;
  }

  function scan(root) {
    mute(root);
    if (root.querySelectorAll) root.querySelectorAll('video').forEach(mute);
  }

  // Capture also catches non-bubbling media events without per-video listeners.
  ['play', 'loadedmetadata', 'volumechange'].forEach(function (name) {
    document.addEventListener(name, function (event) { mute(event.target); }, true);
  });

  scan(document);
  var observer = new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}());
